const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg504ErrorGatewayTimeoutAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.41,367.16l0,11.4a1.12,1.12,0,0,0,1,1.1l7.8.49v11h0a.67.67,0,0,0,.38.56l8.22,4.74a2,2,0,0,0,1,.21v0a1.89,1.89,0,0,0,.77-.15L89,392.65a3.12,3.12,0,0,1,1.91-.11,49.48,49.48,0,0,0,6.46,1.54,1.57,1.57,0,0,1,1.21,1.17l1,5.49a1.18,1.18,0,0,0,.45.71h0a1.28,1.28,0,0,0,.77.28h12.08a1.2,1.2,0,0,0,.69-.26.66.66,0,0,0,.15-.14.83.83,0,0,0,.17-.15v-.13c.07-.11.18-.2.2-.32l1-5.49a1.57,1.57,0,0,1,1.21-1.17,49.48,49.48,0,0,0,6.46-1.54,3.12,3.12,0,0,1,1.91.11l8.33,3.86a1.93,1.93,0,0,0,.5.09v0a2.8,2.8,0,0,0,.29,0h.22a2,2,0,0,0,.79-.2h0l8.21-4.74a.78.78,0,0,0,.29-.28l0,0a.42.42,0,0,0,.06-.21l0,0h0v-4.67h0v-6.31h0l7.65-.49h.15c.08,0,.12-.07.19-.09a1.09,1.09,0,0,0,.53-.25,1.38,1.38,0,0,0,.16-.39c0-.11.14-.21.14-.34h0v-6.1h0v-4.28h0v-6.1a1.09,1.09,0,0,0-1-1.09l-7.8-.5v-11a.66.66,0,0,0-.38-.59l-8.21-4.74a2.22,2.22,0,0,0-1.82-.08L124.74,348a3.09,3.09,0,0,1-1.9.11,50,50,0,0,0-6.47-1.54,1.55,1.55,0,0,1-1.2-1.17l-1-5.48a1.28,1.28,0,0,0-1.21-1H100.83a1.29,1.29,0,0,0-1.22,1l-1,5.48a1.58,1.58,0,0,1-1.2,1.17,49.63,49.63,0,0,0-6.47,1.54A3.09,3.09,0,0,1,89,348l-8.33-3.86a2.22,2.22,0,0,0-1.82.08l-8.22,4.74a.67.67,0,0,0-.38.6h0v10.94l-7.79.5a1.1,1.1,0,0,0-1,1.09V367A1.49,1.49,0,0,0,61.41,367.16ZM93,371c7.66-4.42,20.09-4.42,27.76,0,.58.34,1.11.68,1.61,1a16.58,16.58,0,0,1-1.61,1.05c-7.67,4.43-20.1,4.43-27.76,0a16,16,0,0,1-1.61-1.05C91.87,371.72,92.4,371.38,93,371Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.41,367.17l0,11.4a1.1,1.1,0,0,0,1,1.08l7.79.5v11a.67.67,0,0,0,.38.56l8.22,4.74a2,2,0,0,0,1,.22h0a1.74,1.74,0,0,0,.77-.15L89,392.66a2.35,2.35,0,0,1,.79-.19h0a2.91,2.91,0,0,1,1.12.08,49.48,49.48,0,0,0,6.46,1.54,1.26,1.26,0,0,1,.51.21v.06a1.5,1.5,0,0,1,.7.9l1,5.49a1.23,1.23,0,0,0,.45.71h0a1.28,1.28,0,0,0,.77.28h12.08l.22,0a1.28,1.28,0,0,0,.79-.52v-.13c.07-.11.18-.2.2-.32l1-5.49a1.43,1.43,0,0,1,.48-.79v0a1.49,1.49,0,0,1,.72-.36,49.48,49.48,0,0,0,6.46-1.54,3,3,0,0,1,1.28-.06v0a2.33,2.33,0,0,1,.63.15l8.33,3.85a1.93,1.93,0,0,0,.5.09v0h0a2.17,2.17,0,0,0,1.3-.22h0l8.21-4.74a1.4,1.4,0,0,0,.18-.13,1.53,1.53,0,0,0,.13-.16.5.5,0,0,0,.07-.25h0v-11l1.43-.09,6.23-.4h.14a1.1,1.1,0,0,0,1-1.07V368.16a1.09,1.09,0,0,1-1,1.09l-10.95.7a2,2,0,0,0-1.48,1,16.86,16.86,0,0,1-2.32,3.23.86.86,0,0,0,.12,1.33l6.51,4.68a.62.62,0,0,1-.06,1.12L134.89,386a2.19,2.19,0,0,1-1.82.08l-8.33-3.86a3.11,3.11,0,0,0-1.91-.11,49.1,49.1,0,0,1-6.46,1.54,1.56,1.56,0,0,0-1.2,1.17l-1,5.48a1.28,1.28,0,0,1-1.21,1H100.83a1.29,1.29,0,0,1-1.22-1l-1-5.48a1.59,1.59,0,0,0-1.2-1.17,49.25,49.25,0,0,1-6.47-1.54,3.12,3.12,0,0,0-1.91.11l-8.33,3.86a2.16,2.16,0,0,1-1.81-.08l-8.22-4.74a.61.61,0,0,1-.06-1.11l6.52-4.69a.87.87,0,0,0,.12-1.34,17,17,0,0,1-2.33-3.22,2,2,0,0,0-1.47-1l-10.95-.69a1.12,1.12,0,0,1-1-1.1v-1.22A1.79,1.79,0,0,0,61.41,367.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,349.53v10.94l3.16-.2a2,2,0,0,0,1.47-1,16.69,16.69,0,0,1,2.33-3.22.87.87,0,0,0-.12-1.34l-6.52-4.68a.74.74,0,0,1-.32-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53,356.07a16.5,16.5,0,0,1,2.32,3.22,2,2,0,0,0,1.48,1l3.15.2v-11a.75.75,0,0,1-.33.54l-6.51,4.68A.87.87,0,0,0,136.53,356.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.07,344.11,124.74,348a3.09,3.09,0,0,1-1.9.11,50,50,0,0,0-6.47-1.54,1.55,1.55,0,0,1-1.2-1.17l-1-5.48a1.28,1.28,0,0,0-1.21-1H100.83a1.29,1.29,0,0,0-1.22,1l-1,5.48a1.58,1.58,0,0,1-1.2,1.17,49.63,49.63,0,0,0-6.47,1.54A3,3,0,0,1,89,348l-8.33-3.86a2.22,2.22,0,0,0-1.82.08l-8.22,4.74a.62.62,0,0,0,0,1.12l6.51,4.68a.87.87,0,0,1,.12,1.34,16.57,16.57,0,0,0-2.33,3.22,2,2,0,0,1-1.48,1l-10.94.7a1.1,1.1,0,0,0-1,1.09v6.11a1.12,1.12,0,0,0,1,1.09L73.4,370a2,2,0,0,1,1.48,1,16.57,16.57,0,0,0,2.33,3.22.87.87,0,0,1-.12,1.34l-6.51,4.69a.61.61,0,0,0,0,1.11L78.85,386a2.22,2.22,0,0,0,1.82.08L89,382.25a3.12,3.12,0,0,1,1.91-.11,49.25,49.25,0,0,0,6.47,1.54,1.58,1.58,0,0,1,1.2,1.17l1,5.49a1.29,1.29,0,0,0,1.22,1h12.08a1.28,1.28,0,0,0,1.21-1l1-5.49a1.55,1.55,0,0,1,1.2-1.17,50,50,0,0,0,6.47-1.54,3.09,3.09,0,0,1,1.9.11l8.33,3.86a2.22,2.22,0,0,0,1.82-.08l8.21-4.74a.61.61,0,0,0,.06-1.11l-6.51-4.69a.86.86,0,0,1-.12-1.33,16.86,16.86,0,0,0,2.32-3.23,2,2,0,0,1,1.48-1l10.95-.7a1.09,1.09,0,0,0,1-1.09v-6.1a1.09,1.09,0,0,0-1-1.09l-10.95-.7a2,2,0,0,1-1.48-1,16.5,16.5,0,0,0-2.32-3.22.87.87,0,0,1,.12-1.34l6.51-4.68a.62.62,0,0,0-.06-1.12l-8.21-4.74A2.22,2.22,0,0,0,133.07,344.11Zm-12.32,13c7.66,4.42,7.66,11.6,0,16s-20.1,4.43-27.76,0-7.67-11.6,0-16S113.08,352.67,120.75,357.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,380.72a.7.7,0,0,0-.33-.55l-3.28-2.35v-7.76a1.48,1.48,0,0,1,.45-.11l10.95-.7a1.09,1.09,0,0,0,1-1.09v10.42a1.1,1.1,0,0,1-1,1.07h-.14l-6.23.4-1.43.09S143.49,380.93,143.49,380.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.11,382.09a2.23,2.23,0,0,1,.63.16l8.33,3.86a2.09,2.09,0,0,0,1.07.14v10.4a2.62,2.62,0,0,1-.56,0h0v0a1.93,1.93,0,0,1-.5-.09l-8.33-3.85a2.33,2.33,0,0,0-.63-.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,390.73a1.14,1.14,0,0,0,.15-.4l1-5.48a1.08,1.08,0,0,1,.16-.42v10.41a1,1,0,0,0-.16.41l-1,5.49a.76.76,0,0,1-.15.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.41,384.43a1.52,1.52,0,0,1,.16.42l1,5.48a1.09,1.09,0,0,0,.16.4v10.4a1.11,1.11,0,0,1-.16-.39l-1-5.49a1.28,1.28,0,0,0-.16-.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,386.25a2,2,0,0,0,1.06-.14L89,382.25a2.32,2.32,0,0,1,.63-.16v10.4a2,2,0,0,0-.63.17l-8.33,3.85a1.74,1.74,0,0,1-.77.15H79.6Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.46,369.26l10.95.69a1.56,1.56,0,0,1,.45.11v7.76l-3.29,2.36a.7.7,0,0,0-.32.55v-.58l-7.79-.5a1.1,1.1,0,0,1-1-1.08l0-11.4a1.79,1.79,0,0,1,0-.23v1.22A1.12,1.12,0,0,0,62.46,369.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,331v0h0a.39.39,0,0,0-.06-.21h0c0-3.75,0-10.25,0-10.66v0a.85.85,0,0,0-.19-.51l-3.33-4.64a1.59,1.59,0,0,0-1.37-.65l-8.7,1.46a2.7,2.7,0,0,1-1.66-.47c-.55-.38-1.13-.74-1.73-1.09v-6.92h0c0-.28-.26-.54-.69-.65l-8.83-2.11a1.66,1.66,0,0,0-1.43.27l-4.22,4.45a2,2,0,0,1-1.39.43,46,46,0,0,0-5.75,0,2.28,2.28,0,0,1-1.56-.68l-3.78-4a1.74,1.74,0,0,0-1.48-.54l-9.18,2.19a.6.6,0,0,0-.47.61s0,0,0,0c0,.38,0,3.67,0,6.86-.72.41-1.4.84-2,1.3a2.3,2.3,0,0,1-1.51.26L159,314.26a1.52,1.52,0,0,0-1.34.39l-3.66,5.1a.4.4,0,0,0-.08.23v0c0,.77,0,13.16,0,13.24a.47.47,0,0,0,.07.22c0,3.81,0,6.54,0,6.7a1,1,0,0,0,.19.54l3.33,4.64a1.57,1.57,0,0,0,1.37.64l8.7-1.46a2.76,2.76,0,0,1,1.66.47c.55.39,1.13.75,1.73,1.1V353c0,.28.25.56.69.67l8.83,2.11a1.66,1.66,0,0,0,1.43-.27l4.22-4.45a2,2,0,0,1,1.39-.43,46.11,46.11,0,0,0,5.76,0,2.3,2.3,0,0,1,1.55.67l3.78,4a1.76,1.76,0,0,0,1.48.55l9.18-2.2a.58.58,0,0,0,.47-.5c0-.15,0-7,0-7,.72-.41,1.4-.84,2.05-1.3a2.36,2.36,0,0,1,1.51-.26l8.43,1.42a1.48,1.48,0,0,0,1.34-.39l3.66-5.1a.46.46,0,0,0,.08-.23c0-.25,0-8.84,0-9.31Zm-49.16.27c.4-.29.84-.56,1.31-.84,6.31-3.64,16.53-3.64,22.84,0,.46.27.9.55,1.29.82a12.27,12.27,0,0,1-1.39.9c-4.48,2.55-11.34,3.45-17.52,2a19.5,19.5,0,0,1-5.18-2A12,12,0,0,1,177.65,331.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,313.08c-.7.32-1.38.67-2,1v-6.86a.83.83,0,0,0,.11.35l2.2,4.36A.8.8,0,0,1,173,313.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,324a9.27,9.27,0,0,0,0,2.88.91.91,0,0,1-.59,1l-7.94,2.52a.5.5,0,0,0-.37.5v2.59a.48.48,0,0,1-.07-.2c0-4.51,0-12,0-12.71V320c0,.25.25.48.64.6l7.5,2.38A1,1,0,0,1,162.88,324Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.86,335.21v9.33a1.14,1.14,0,0,0-.32,0l-8.7,1.46a1,1,0,0,1-.44,0v-9.31a1.21,1.21,0,0,0,.46,0l8.7-1.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,346.11c-.6-.35-1.18-.71-1.72-1.09a3,3,0,0,0-1.35-.48v-9.33a3,3,0,0,1,1.36.49,26.21,26.21,0,0,0,3.52,2c.52.25.81.7.64,1L171,343.51a.49.49,0,0,0-.05.2C170.94,344,170.93,346.11,170.93,346.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,341.44v9.32a1.39,1.39,0,0,0-.54.3l-4.22,4.45a1.36,1.36,0,0,1-.77.31V346.5a1.3,1.3,0,0,0,.79-.3l4.23-4.46A1.3,1.3,0,0,1,186.64,341.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8,341.39v9.32a1.66,1.66,0,0,0-.55-.09,48.12,48.12,0,0,1-5.76,0,2.26,2.26,0,0,0-.85.13v-9.32a2.36,2.36,0,0,1,.87-.13,46,46,0,0,0,5.75,0A1.57,1.57,0,0,1,193.8,341.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.43,346.45v9.32a2,2,0,0,1-.85-.49l-3.78-4a2.38,2.38,0,0,0-1-.58v-9.32a2.43,2.43,0,0,1,1,.59l3.78,4A2,2,0,0,0,199.43,346.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,343.82v2.3h0v3.66c0,1.66,0,3.27,0,3.34a.58.58,0,0,1-.47.5l-9.18,2.2a1.39,1.39,0,0,1-.63-.05v-9.32a1.2,1.2,0,0,0,.64.05l9.19-2.2A.55.55,0,0,0,209.72,343.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,335.23v9.32a2,2,0,0,0-.92.28c-.65.45-1.33.88-2.05,1.29,0,0,0-2.13,0-2.42a.8.8,0,0,0-.1-.38l-2.2-4.36a.79.79,0,0,1,.28-1.11,25.87,25.87,0,0,0,4.08-2.34A1.81,1.81,0,0,1,212.69,335.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,331c0,.46,0,9.06,0,9.31a.53.53,0,0,1-.08.23l-3.66,5.1a1.11,1.11,0,0,1-.63.36v-9.31a1.17,1.17,0,0,0,.65-.36l3.65-5.11A.3.3,0,0,0,226.8,331Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,307.23s0,0,0,0a.69.69,0,0,0,.1.35l2.19,4.36a.79.79,0,0,1-.27,1.11c-.7.33-1.38.67-2,1s-1.4.84-2,1.3a2.3,2.3,0,0,1-1.51.26L159,314.26a1.52,1.52,0,0,0-1.34.39l-3.66,5.1a.4.4,0,0,0-.08.23v0c0,.24.25.47.64.59l7.5,2.38a1,1,0,0,1,.82,1,9.27,9.27,0,0,0,0,2.88.92.92,0,0,1-.59,1l-7.94,2.52a.5.5,0,0,0-.37.5,1,1,0,0,0,.18.52l3.34,4.64a1.56,1.56,0,0,0,1.37.64l8.7-1.47a2.71,2.71,0,0,1,1.66.48,26.34,26.34,0,0,0,3.53,2c.51.25.8.7.63,1L171,343.51c-.17.34.12.71.65.84l8.83,2.11a1.63,1.63,0,0,0,1.42-.26l4.23-4.45a2,2,0,0,1,1.39-.44,48,48,0,0,0,5.75,0,2.26,2.26,0,0,1,1.56.67l3.78,4a1.77,1.77,0,0,0,1.47.54l9.19-2.19a.65.65,0,0,0,.37-1l-2.2-4.36a.8.8,0,0,1,.28-1.11,25.76,25.76,0,0,0,4.07-2.34,2.31,2.31,0,0,1,1.51-.26l8.44,1.41a1.46,1.46,0,0,0,1.34-.39l3.65-5.09a.34.34,0,0,0,.08-.23h0v0a.39.39,0,0,0-.06-.21h0a1,1,0,0,0-.58-.4l-7.5-2.38c-.53-.17-.89-.6-.82-1a9.21,9.21,0,0,0,0-2.87,1,1,0,0,1,.59-1l7.95-2.52a.5.5,0,0,0,.37-.48v0a.85.85,0,0,0-.19-.51l-3.33-4.64a1.59,1.59,0,0,0-1.37-.65l-8.7,1.46a2.7,2.7,0,0,1-1.66-.47c-.55-.38-1.13-.74-1.73-1.09s-1.17-.64-1.8-.94-.81-.71-.63-1l2.39-4.74a.34.34,0,0,0,0-.19c0-.28-.26-.54-.69-.65l-8.83-2.11a1.66,1.66,0,0,0-1.43.27l-4.22,4.45a2,2,0,0,1-1.39.43,46,46,0,0,0-5.75,0,2.28,2.28,0,0,1-1.56-.68l-3.78-4a1.74,1.74,0,0,0-1.48-.54l-9.18,2.19A.6.6,0,0,0,171,307.23Zm33.4,13.63.22.23.16.17.33.4c.12.15.23.32.34.48s.13.2.19.3l.09.15a5.72,5.72,0,0,1-.44,6.44,9.81,9.81,0,0,1-2.19,2.17,11,11,0,0,1-1.39.9c-4.48,2.55-11.34,3.45-17.52,2a19.5,19.5,0,0,1-5.18-2,12,12,0,0,1-1.35-.87,9.18,9.18,0,0,1-2.76-3.07s0,0,0,0a1.62,1.62,0,0,1-.1-.18c0-.07-.06-.13-.08-.19s-.06-.13-.09-.21a5.71,5.71,0,0,1,.83-5.63c3.41-4.76,12.86-7,21.1-5A16.32,16.32,0,0,1,204.39,320.86Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-504--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.77,98.33a1.1,1.1,0,0,0-.25-.19l-7.9-4.58V56.19a2.52,2.52,0,0,0-.62-1.91,1.46,1.46,0,0,0-.25-.2l-10.29-5.94a1.18,1.18,0,0,0-1.22.09L201.52,55a5.48,5.48,0,0,0-1.59,1.34,11.28,11.28,0,0,0-1.28,2.47l-23.21,58.46a15.8,15.8,0,0,0-1,5.72v12.66a2.59,2.59,0,0,0,.62,1.92,1.17,1.17,0,0,0,.3.21c.34.18,10.14,5.86,10.22,5.91a1.15,1.15,0,0,0,1.24-.08L201,135.43v.31a2.59,2.59,0,0,0,.62,1.92,1.18,1.18,0,0,0,.22.17c.36.23,10.26,5.93,10.36,6a1.19,1.19,0,0,0,1.18-.11l10.17-5.87A3.9,3.9,0,0,0,225,136a6,6,0,0,0,.62-2.63V121.2l6.68-3.85a3.9,3.9,0,0,0,1.47-1.81,6,6,0,0,0,.62-2.63V100.24A2.54,2.54,0,0,0,233.77,98.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.65 110.15 211.65 88.16 200.32 116.69 211.65 110.15",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,141.68V129.49L201,135.43v.31a2.59,2.59,0,0,0,.62,1.92,1.18,1.18,0,0,0,.22.17c.36.23,10.26,5.93,10.36,6h0a1.36,1.36,0,0,1-.32-.23A2.55,2.55,0,0,1,211.26,141.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,143.5l.1.11-10.1-5.83a1.37,1.37,0,0,1-.28-.21,2.55,2.55,0,0,1-.63-1.92V123a16.74,16.74,0,0,1,.29-3.14L185,125.79h0a16.54,16.54,0,0,0-.28,3.12V141.6A2.5,2.5,0,0,0,185.34,143.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,61.57a5,5,0,0,0-.69.7,11,11,0,0,0-1.27,2.48L185.72,123.2a14,14,0,0,0-.72,2.59l-10.28-5.94a13.88,13.88,0,0,1,.73-2.58l23.2-58.45a11.17,11.17,0,0,1,1.28-2.48,4.53,4.53,0,0,1,.68-.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.36,143.7a1.13,1.13,0,0,1-1.48-.11,2.55,2.55,0,0,1-.62-1.91V129.49l-24.45,14.12a1.13,1.13,0,0,1-1.47-.1,2.55,2.55,0,0,1-.62-1.92V128.92a15.84,15.84,0,0,1,1-5.72l23.21-58.45a11.49,11.49,0,0,1,1.28-2.47,5.26,5.26,0,0,1,1.6-1.34l11.72-6.77a1.12,1.12,0,0,1,1.47.11,2.52,2.52,0,0,1,.62,1.91v45.89l6.68-3.85a1.12,1.12,0,0,1,1.47.1,2.54,2.54,0,0,1,.62,1.91v12.67a6,6,0,0,1-.62,2.63,3.9,3.9,0,0,1-1.47,1.81l-6.68,3.85v12.19A6,6,0,0,1,225,136a3.9,3.9,0,0,1-1.47,1.81Zm-1.71-33.55v-22l-11.33,28.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.26,106.87h0l-.06,0h0l-12.09-7h0l-.07,0h0c-5.71-3.25-13.57-2.75-22.25,2.26-17.44,10.07-31.58,34.55-31.58,54.69,0,10,3.51,17.1,9.2,20.41h0l0,0h0l12.09,7h0l.06,0h0c5.71,3.26,13.57,2.77,22.26-2.25,17.44-10.07,31.58-34.55,31.58-54.69C180.46,117.24,177,110.18,171.26,106.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.14,183.93l-11.67-6.77h0l-.06,0c-5.68-3.32-9.19-10.38-9.19-20.4,0-9,2.82-18.83,7.47-27.86l12.09,7c-4.66,9-7.47,18.88-7.47,27.86C117.3,173.56,120.67,180.53,126.14,183.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.88,
    cy: 145.51,
    rx: 44.66,
    ry: 25.78,
    transform: "translate(-51.57 201.69) rotate(-60)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,178.68c-9.64,0-10.68-10.89-10.68-15.58,0-17.14,12.54-38.86,27.38-47.43a21.85,21.85,0,0,1,10.52-3.33c9.65,0,10.69,10.89,10.69,15.58,0,17.14-12.54,38.86-27.39,47.43a21.79,21.79,0,0,1-10.52,3.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.88,166.09a.4.4,0,0,1-.15,0,.45.45,0,0,1-.28-.58l7-20a.46.46,0,1,1,.86.31l-7,20A.45.45,0,0,1,141.88,166.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.37,151.55a1.31,1.31,0,0,1-.54-.11l-11.32-4.89V126a1.38,1.38,0,0,1,2.75,0v18.72l9.66,4.18a1.37,1.37,0,0,1-.55,2.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,141.22c2.05-1.18,3.72-.22,3.72,2.15a8.22,8.22,0,0,1-3.72,6.43c-2,1.19-3.71.22-3.71-2.14A8.23,8.23,0,0,1,148.88,141.22Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,161.3a12.54,12.54,0,0,0-4.42-6.29c-.2-.14-.4-.27-.61-.39-1.75-1-10.06-5.8-10.26-5.92a9.32,9.32,0,0,0-2.83-1.08l14.59-8.43a3.94,3.94,0,0,0,1.48-1.8,6.17,6.17,0,0,0,.62-2.63V122.09a2.56,2.56,0,0,0-.62-1.91,1.15,1.15,0,0,0-.26-.19L98.24,114a1.15,1.15,0,0,0-1.21.1L63.81,133.32a3.75,3.75,0,0,0-1.44,1.78,7.43,7.43,0,0,0-.66,2.65l-2.33,44a2.45,2.45,0,0,0,.54,2l.24.18,7.28,4.2-8.68,5a3.15,3.15,0,0,0-1.2,1.47,4.94,4.94,0,0,0-.51,2.14,23,23,0,0,0,1.63,8.56,11.86,11.86,0,0,0,4.43,5.57l.41.26,10.29,5.94a11.27,11.27,0,0,0,6.61,1.3A22.76,22.76,0,0,0,89.85,215a40.48,40.48,0,0,0,8.85-7,47.3,47.3,0,0,0,7.18-9.82,53.68,53.68,0,0,0,4.81-12,52.63,52.63,0,0,0,1.74-13.67A32.9,32.9,0,0,0,110.84,161.3Zm-27,21.43A4.86,4.86,0,0,0,85,181.58c.47-.59,1-1.22,1.52-1.89.27-.34.55-.67.84-1-.08.35-.16.69-.26,1A18.76,18.76,0,0,1,85.31,184a17.93,17.93,0,0,1-2.64,3.5A14.55,14.55,0,0,1,79.56,190a8.22,8.22,0,0,1-2.33,1l-3.78-2.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.39,216.8l.38.23-10.25-5.91-.41-.25a11.94,11.94,0,0,1-4.43-5.58,23,23,0,0,1-1.62-8.56,4.89,4.89,0,0,1,.42-1.95l10.28,5.94a4.91,4.91,0,0,0-.43,1.95A22.86,22.86,0,0,0,69,211.23,11.84,11.84,0,0,0,73.39,216.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.07,180.74a18.06,18.06,0,0,1-.65,4.92,18.53,18.53,0,0,1-1.83,4.28,17.84,17.84,0,0,1-2.64,3.5,14.83,14.83,0,0,1-3.1,2.45A7,7,0,0,1,86.74,197a4.51,4.51,0,0,1-2.25-.43,5,5,0,0,1-1.59-1.29c-.44-.54-.84-1.07-1.2-1.58a1.94,1.94,0,0,0-.74-.58l-.16-.1-3.57-2a8.34,8.34,0,0,0,2.33-1,14.62,14.62,0,0,0,3.11-2.45A18.16,18.16,0,0,0,85.31,184a19,19,0,0,0,1.82-4.28c.1-.35.19-.69.26-1,.3-.34.62-.69,1-1a9.06,9.06,0,0,1,2-1.67q3.57-2.06,5.63-.68C97.39,176.22,98.07,178,98.07,180.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,140.56c-.08.15-.16.31-.23.48a7.4,7.4,0,0,0-.67,2.65l-2.33,44a2.45,2.45,0,0,0,.55,2l-10-5.76a1.25,1.25,0,0,1-.24-.18,2.45,2.45,0,0,1-.54-2l2.33-44a7.28,7.28,0,0,1,.66-2.65c.08-.18.16-.33.25-.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,193.66c.36.51.76,1,1.2,1.58a5,5,0,0,0,1.59,1.29,4.51,4.51,0,0,0,2.25.43,7,7,0,0,0,3.11-1.07,14.83,14.83,0,0,0,3.1-2.45,18,18,0,0,0,5.12-12.7c0-2.71-.68-4.52-2-5.45s-3.25-.69-5.63.68a9.05,9.05,0,0,0-2.06,1.67c-.64.69-1.24,1.37-1.78,2.05s-1,1.3-1.52,1.89a4.86,4.86,0,0,1-1.16,1.15l-12.11,7a1.18,1.18,0,0,1-1.55-.06,2.41,2.41,0,0,1-.55-2l2.33-44a7.6,7.6,0,0,1,.66-2.65,3.78,3.78,0,0,1,1.44-1.79l33.22-19.18a1.13,1.13,0,0,1,1.48.11,2.56,2.56,0,0,1,.62,1.91v12.67a6.17,6.17,0,0,1-.62,2.63,3.94,3.94,0,0,1-1.48,1.8L84.72,152.24l-.54,10.95a28.63,28.63,0,0,1,3.22-3.84,19.68,19.68,0,0,1,4-3.08,20.28,20.28,0,0,1,8.34-2.91,10,10,0,0,1,6.68,1.65,12.54,12.54,0,0,1,4.42,6.29,32.9,32.9,0,0,1,1.59,11.15,52.63,52.63,0,0,1-1.74,13.67,53.68,53.68,0,0,1-4.81,12A47.3,47.3,0,0,1,98.7,208a40.48,40.48,0,0,1-8.85,7,22.76,22.76,0,0,1-9.43,3.35,11,11,0,0,1-7-1.56A11.84,11.84,0,0,1,69,211.23a22.82,22.82,0,0,1-1.63-8.56,4.89,4.89,0,0,1,.5-2.14,3.25,3.25,0,0,1,1.2-1.48l9.86-5.69c.83-.48,1.46-.6,1.9-.38A2.49,2.49,0,0,1,81.7,193.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,265.55a13.3,13.3,0,0,1,.33-2.78,11.39,11.39,0,0,1,.89-2.52,9.74,9.74,0,0,1,1.43-2.12,8,8,0,0,1,2-1.61,4.43,4.43,0,0,1,2.2-.74,2.17,2.17,0,0,1,1.38.48,2.42,2.42,0,0,1,.72,1.12,5.38,5.38,0,0,1,.23,1.19,1,1,0,0,1-.11.53.89.89,0,0,1-.3.35l-1.24.71q-.16.1-.27,0a.47.47,0,0,1-.15-.19,3,3,0,0,0-.16-.32,1.09,1.09,0,0,0-.41-.42,1.37,1.37,0,0,0-.74-.18,2.26,2.26,0,0,0-1.15.39,4.69,4.69,0,0,0-1.84,2,7,7,0,0,0-.74,3c0,.61,0,1.26,0,1.94s0,1.32,0,1.91c0,1.28.28,2.09.74,2.41s1.07.27,1.84-.17a5.29,5.29,0,0,0,1-.79,4.52,4.52,0,0,0,.82-1.09,5.75,5.75,0,0,0,.54-1.43,8.34,8.34,0,0,0,.19-1.82v-.19l-1.87,1.08a.22.22,0,0,1-.29,0,.53.53,0,0,1-.13-.38v-1.68a1.2,1.2,0,0,1,.13-.51.73.73,0,0,1,.29-.36l3.52-2a.23.23,0,0,1,.29,0,.45.45,0,0,1,.13.37v2.6a13.42,13.42,0,0,1-.29,2.77,11.38,11.38,0,0,1-.88,2.56,9.8,9.8,0,0,1-1.45,2.19,8.63,8.63,0,0,1-2,1.66,4.48,4.48,0,0,1-2,.69,1.92,1.92,0,0,1-1.43-.5,3.31,3.31,0,0,1-.87-1.54,8.9,8.9,0,0,1-.32-2.41c0-.3,0-.62,0-1s0-.73,0-1.11,0-.74,0-1.11S85.05,265.85,85.07,265.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.14,250.16c.16-.1.29-.1.37,0a1.21,1.21,0,0,1,.21.48l3.76,12.74a.81.81,0,0,1,0,.16,1.23,1.23,0,0,1-.12.52.84.84,0,0,1-.29.36L104,265c-.2.12-.34.14-.42.05a.62.62,0,0,1-.17-.29l-.66-2.24-4.84,2.8-.66,3a2.39,2.39,0,0,1-.17.49,1,1,0,0,1-.43.45l-1.1.64a.24.24,0,0,1-.3,0,.52.52,0,0,1-.12-.38,1.1,1.1,0,0,1,0-.18l3.75-17.07a3.38,3.38,0,0,1,.22-.73.85.85,0,0,1,.36-.41ZM102,260l-1.68-5.76L98.61,262Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.94,243.34a.22.22,0,0,1,.29,0,.52.52,0,0,1,.12.38v1.67a1.2,1.2,0,0,1-.12.52.73.73,0,0,1-.29.36l-2.76,1.59v12.93a1.2,1.2,0,0,1-.12.52.84.84,0,0,1-.29.36l-1.24.72a.22.22,0,0,1-.29,0,.45.45,0,0,1-.13-.37V249.08l-2.76,1.59a.21.21,0,0,1-.29,0,.52.52,0,0,1-.12-.38V248.6a1.2,1.2,0,0,1,.12-.52.91.91,0,0,1,.29-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,251.66a.22.22,0,0,1,.29,0,.52.52,0,0,1,.12.38v1.67a1.2,1.2,0,0,1-.12.52.73.73,0,0,1-.29.36l-6.73,3.88a.21.21,0,0,1-.29,0,.48.48,0,0,1-.12-.37V242.86a1.2,1.2,0,0,1,.12-.52.73.73,0,0,1,.29-.36l6.6-3.81a.23.23,0,0,1,.3,0,.5.5,0,0,1,.12.37v1.68a1.23,1.23,0,0,1-.12.52.85.85,0,0,1-.3.36L117,244v3.75l4.62-2.66a.22.22,0,0,1,.29,0,.52.52,0,0,1,.12.38v1.68a1.19,1.19,0,0,1-.12.51.73.73,0,0,1-.29.36L117,250.67v3.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,242.56,128,250.38a3.48,3.48,0,0,1-.19.68.83.83,0,0,1-.34.43l-1.25.71c-.15.09-.27.09-.35,0a.89.89,0,0,1-.18-.48l-2-13.75c0-.08,0-.14,0-.18a1.2,1.2,0,0,1,.12-.52.79.79,0,0,1,.3-.36l1.13-.65a.31.31,0,0,1,.29,0q.14.06.18.39l1.29,9.26,1.14-7a3.4,3.4,0,0,1,.14-.51.92.92,0,0,1,.39-.49l1.26-.72q.27-.16.39,0a1.07,1.07,0,0,1,.15.34l1.13,5.64,1.29-10.74a1.47,1.47,0,0,1,.18-.6.88.88,0,0,1,.29-.31l1.14-.66a.23.23,0,0,1,.29,0,.52.52,0,0,1,.12.38s0,.11,0,.2l-2,16a2.71,2.71,0,0,1-.17.68.92.92,0,0,1-.36.43l-1.25.72c-.15.09-.26.08-.34,0a1.23,1.23,0,0,1-.19-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.09,227.09c.16-.09.29-.1.37,0a1.08,1.08,0,0,1,.21.48l3.76,12.74a.66.66,0,0,1,0,.15,1.2,1.2,0,0,1-.12.52.73.73,0,0,1-.29.36l-1.1.64c-.21.12-.35.13-.43.05a.65.65,0,0,1-.17-.3l-.66-2.24-4.84,2.8-.66,3a2.62,2.62,0,0,1-.17.49,1,1,0,0,1-.43.44l-1.1.64a.23.23,0,0,1-.3,0,.51.51,0,0,1-.12-.38.88.88,0,0,1,0-.17l3.75-17.08a2.94,2.94,0,0,1,.22-.72.88.88,0,0,1,.36-.42Zm.84,9.87-1.68-5.75-1.69,7.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,219.75a.21.21,0,0,1,.29,0,.48.48,0,0,1,.12.37.85.85,0,0,1,0,.23l-3.63,11.94v5.19a1.23,1.23,0,0,1-.12.52.75.75,0,0,1-.29.35l-1.23.71a.21.21,0,0,1-.29,0,.51.51,0,0,1-.12-.38v-5.19l-3.63-7.74a.49.49,0,0,1,0-.19A1.25,1.25,0,0,1,145,225a.84.84,0,0,1,.29-.36l1.15-.66c.2-.12.36-.13.46,0a.66.66,0,0,1,.18.25l2.48,5.24,2.49-8.11a2.85,2.85,0,0,1,.18-.46,1.12,1.12,0,0,1,.46-.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.61,212.93a.24.24,0,0,1,.29,0,.52.52,0,0,1,.12.38V215a1.27,1.27,0,0,1-.12.52.75.75,0,0,1-.29.35l-2.76,1.6V230.4a1.2,1.2,0,0,1-.12.52.73.73,0,0,1-.29.36l-1.25.72a.23.23,0,0,1-.29,0,.52.52,0,0,1-.12-.38V218.67L158,220.26a.21.21,0,0,1-.29,0,.51.51,0,0,1-.12-.38v-1.67a1.23,1.23,0,0,1,.12-.52.84.84,0,0,1,.29-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,228.09a.24.24,0,0,1-.29,0,.53.53,0,0,1-.13-.38V212.45a1.21,1.21,0,0,1,.13-.52.84.84,0,0,1,.29-.36l1.24-.72a.23.23,0,0,1,.29,0,.48.48,0,0,1,.12.37v15.24a1.2,1.2,0,0,1-.12.52.73.73,0,0,1-.29.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,214.76l2.91-9.47.21-.5a1.1,1.1,0,0,1,.45-.52l1-.6a.22.22,0,0,1,.29,0,.49.49,0,0,1,.13.38v15.24a1.11,1.11,0,0,1-.13.52.84.84,0,0,1-.29.36l-1.24.71a.21.21,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-9.23l-2,6.46a4.64,4.64,0,0,1-.21.51,1,1,0,0,1-.35.41l-.8.46a.28.28,0,0,1-.35,0,1.13,1.13,0,0,1-.22-.27l-2-4.15v9.22a1.23,1.23,0,0,1-.12.52.84.84,0,0,1-.29.36l-1.24.71a.21.21,0,0,1-.29,0,.47.47,0,0,1-.13-.38V209.87a1.14,1.14,0,0,1,.13-.52.69.69,0,0,1,.29-.35l1-.6c.2-.12.35-.12.45,0l.21.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,211.49a.23.23,0,0,1,.29,0,.48.48,0,0,1,.12.37v1.68a1.27,1.27,0,0,1-.12.52.75.75,0,0,1-.29.35l-6.73,3.89a.22.22,0,0,1-.29,0,.52.52,0,0,1-.12-.38V202.69a1.2,1.2,0,0,1,.12-.52.84.84,0,0,1,.29-.36l6.61-3.81a.22.22,0,0,1,.29,0,.51.51,0,0,1,.12.38v1.67a1.2,1.2,0,0,1-.12.52.84.84,0,0,1-.29.36l-4.95,2.86v3.75l4.61-2.67a.23.23,0,0,1,.29,0,.48.48,0,0,1,.12.37V207a1.27,1.27,0,0,1-.12.52.75.75,0,0,1-.29.35l-4.61,2.67v3.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,201a15.1,15.1,0,0,1,.33-2.68,11.92,11.92,0,0,1,.83-2.51,10,10,0,0,1,1.38-2.17,7.58,7.58,0,0,1,2-1.64,3.93,3.93,0,0,1,2-.63,2,2,0,0,1,1.38.57,3.53,3.53,0,0,1,.84,1.55,9,9,0,0,1,.34,2.3c0,.3,0,.62,0,1s0,.73,0,1.12,0,.76,0,1.12,0,.7,0,1a15.33,15.33,0,0,1-.33,2.68,12.32,12.32,0,0,1-.83,2.51,9.89,9.89,0,0,1-1.39,2.15,7.32,7.32,0,0,1-2,1.63,3.86,3.86,0,0,1-2,.63,1.92,1.92,0,0,1-1.38-.56,3.47,3.47,0,0,1-.83-1.54,9.72,9.72,0,0,1-.33-2.3c0-.29,0-.62,0-1s0-.73,0-1.12,0-.76,0-1.12S197,201.25,197,201Zm6.94-3.89a3,3,0,0,0-.71-2.22c-.44-.37-1-.35-1.73.06a4.41,4.41,0,0,0-1.72,1.93,7.36,7.36,0,0,0-.71,3q0,.91,0,2t0,2a3,3,0,0,0,.71,2.2c.43.37,1,.34,1.72-.07a4.4,4.4,0,0,0,1.73-1.92,7.27,7.27,0,0,0,.71-3q0-.91,0-2C204,198.3,204,197.64,204,197.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,183.63a.22.22,0,0,1,.29,0,.49.49,0,0,1,.13.38v9.67a14.07,14.07,0,0,1-.28,2.8,10.72,10.72,0,0,1-.83,2.51,8.54,8.54,0,0,1-1.38,2.11,7.77,7.77,0,0,1-1.91,1.56,4.11,4.11,0,0,1-1.93.65,1.84,1.84,0,0,1-1.37-.52,3.3,3.3,0,0,1-.82-1.55,9.91,9.91,0,0,1-.26-2.49V189.1a1.23,1.23,0,0,1,.12-.52.84.84,0,0,1,.29-.36l1.24-.71a.21.21,0,0,1,.29,0,.5.5,0,0,1,.12.37v9.56a5.83,5.83,0,0,0,.17,1.55,1.6,1.6,0,0,0,.48.85.94.94,0,0,0,.73.21,2.34,2.34,0,0,0,.94-.34,4.31,4.31,0,0,0,.94-.74,4.15,4.15,0,0,0,.74-1.07,5.9,5.9,0,0,0,.49-1.4,8.51,8.51,0,0,0,.17-1.75v-9.55a1.08,1.08,0,0,1,.13-.52.68.68,0,0,1,.29-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.23,177.93a.24.24,0,0,1,.29,0,.53.53,0,0,1,.13.38V180a1.29,1.29,0,0,1-.13.52.75.75,0,0,1-.29.35l-2.76,1.6V195.4a1.2,1.2,0,0,1-.12.52.78.78,0,0,1-.29.36l-1.24.72a.22.22,0,0,1-.29,0,.49.49,0,0,1-.13-.38V183.67l-2.75,1.59a.23.23,0,0,1-.3,0,.51.51,0,0,1-.12-.38v-1.67a1.2,1.2,0,0,1,.12-.52.85.85,0,0,1,.3-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26,218.68a.26.26,0,0,1,.35,0,.58.58,0,0,1,.15.45v3a1.45,1.45,0,0,1-.15.63.92.92,0,0,1-.35.43l-8.72,5a.27.27,0,0,1-.35,0,.6.6,0,0,1-.15-.45V209.47a1.45,1.45,0,0,1,.15-.63.84.84,0,0,1,.35-.42l8.57-5a.27.27,0,0,1,.35,0,.6.6,0,0,1,.15.45v3a1.45,1.45,0,0,1-.15.62.92.92,0,0,1-.35.43l-5.67,3.27v3.06l5.27-3a.26.26,0,0,1,.35,0,.58.58,0,0,1,.15.45v3a1.45,1.45,0,0,1-.15.63,1,1,0,0,1-.35.43l-5.27,3V222Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.82,198.44a6.45,6.45,0,0,1,2.17-.86,2.36,2.36,0,0,1,1.63.25,2.58,2.58,0,0,1,1,1.43,8.19,8.19,0,0,1,.36,2.67,12.32,12.32,0,0,1-.57,3.86,10,10,0,0,1-1.62,3.07l2.28,5.43a.71.71,0,0,1,.06.28,1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-2.5,1.44c-.25.14-.42.16-.52,0a1.15,1.15,0,0,1-.25-.37l-2-4.88-1.69,1v6.06a1.38,1.38,0,0,1-.15.62.92.92,0,0,1-.35.43l-2.41,1.39a.27.27,0,0,1-.35,0,.6.6,0,0,1-.15-.45V202.37a1.38,1.38,0,0,1,.15-.62,1,1,0,0,1,.35-.43Zm-2.08,9.78,2.08-1.2a3.83,3.83,0,0,0,1.28-1.19,3.33,3.33,0,0,0,.51-1.93q0-1.2-.51-1.35a1.61,1.61,0,0,0-1.28.28l-2.08,1.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,190.79a6.53,6.53,0,0,1,2.17-.86,2.3,2.3,0,0,1,1.63.25,2.54,2.54,0,0,1,1,1.43,8.19,8.19,0,0,1,.36,2.67,12.32,12.32,0,0,1-.57,3.86,10,10,0,0,1-1.62,3.07l2.29,5.43a.87.87,0,0,1,0,.28,1.19,1.19,0,0,1-.12.51.85.85,0,0,1-.28.35l-2.51,1.44c-.24.14-.42.16-.52.05a1.15,1.15,0,0,1-.25-.37l-2-4.88-1.7,1v6.07a1.55,1.55,0,0,1-.14.62,1,1,0,0,1-.35.43l-2.42,1.39a.27.27,0,0,1-.35,0,.65.65,0,0,1-.14-.46v-18.3a1.6,1.6,0,0,1,.14-.63,1,1,0,0,1,.35-.42ZM146,200.57l2.08-1.2a3.65,3.65,0,0,0,1.28-1.19,3.37,3.37,0,0,0,.51-1.94q0-1.19-.51-1.35a1.63,1.63,0,0,0-1.28.29l-2.08,1.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,193.94a15.22,15.22,0,0,1,.45-3.25,14.5,14.5,0,0,1,1.12-3.08,13,13,0,0,1,1.77-2.67,9.17,9.17,0,0,1,2.4-2,4.9,4.9,0,0,1,2.39-.78,2.73,2.73,0,0,1,1.78.62,3.94,3.94,0,0,1,1.12,1.79,9.5,9.5,0,0,1,.45,2.73c0,.8,0,1.64,0,2.53s0,1.73,0,2.52a15.89,15.89,0,0,1-.45,3.25,15.08,15.08,0,0,1-1.12,3.1,12.48,12.48,0,0,1-1.78,2.66,9.42,9.42,0,0,1-2.39,2,4.92,4.92,0,0,1-2.4.79,2.55,2.55,0,0,1-1.77-.62,4,4,0,0,1-1.12-1.8,9.28,9.28,0,0,1-.45-2.73c0-.76,0-1.59,0-2.48S155.39,194.77,155.42,193.94Zm8.08.24c0-.35,0-.73,0-1.16s0-.85,0-1.28,0-.85,0-1.25,0-.76,0-1.07a4.83,4.83,0,0,0-.2-1.19,1.72,1.72,0,0,0-.44-.78,1,1,0,0,0-.71-.29,2,2,0,0,0-1,.32,3.77,3.77,0,0,0-1,.83,4.71,4.71,0,0,0-.71,1.1,6.33,6.33,0,0,0-.44,1.29,8.23,8.23,0,0,0-.2,1.42c0,.33,0,.71,0,1.12s0,.83,0,1.26,0,.86,0,1.27,0,.78,0,1.11a3.08,3.08,0,0,0,.64,2c.37.41.94.4,1.7,0a4,4,0,0,0,1.69-1.92A7.81,7.81,0,0,0,163.5,194.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,175.24a6.53,6.53,0,0,1,2.17-.86,2.36,2.36,0,0,1,1.63.25,2.58,2.58,0,0,1,1,1.43,8.28,8.28,0,0,1,.36,2.67,12.32,12.32,0,0,1-.57,3.86,10,10,0,0,1-1.62,3.07l2.28,5.43a.71.71,0,0,1,.06.28,1.19,1.19,0,0,1-.12.51.74.74,0,0,1-.29.35l-2.5,1.44c-.24.14-.42.16-.52.05a1.15,1.15,0,0,1-.25-.37l-2-4.88-1.69,1v6.06a1.45,1.45,0,0,1-.15.63.84.84,0,0,1-.35.42L170,198a.27.27,0,0,1-.35,0,.58.58,0,0,1-.14-.45V179.17a1.4,1.4,0,0,1,.14-.62,1,1,0,0,1,.35-.43ZM172.92,185l2.08-1.21a3.74,3.74,0,0,0,1.28-1.19,3.33,3.33,0,0,0,.51-1.93q0-1.2-.51-1.35a1.62,1.62,0,0,0-1.28.28l-2.08,1.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.24,362.22c-.09-8.18-3.12-60.14-4.2-72.09-1.83-20.08-1.63-74.33,2.41-91.61l54,4.28c3.86,9.72,6.68,21.7,6,40.47-.5,14.32-.27,53.17-.27,53.17a158.67,158.67,0,0,1,5.43,18.6c2.42,10.5,4.86,42.31,5.93,52.75l0,1.4a4.91,4.91,0,0,1,1,2.16c0,.83-.11,1.67-.08,2.5a8.53,8.53,0,0,1-1.42,5.54,8.64,8.64,0,0,1-3.09,2.95,5.08,5.08,0,0,1-4.17.35c-3.84-1.51-3.28-7.65-4.56-10.85l-.6-1.55s-16.7-50.72-20.75-63.27c-3.42-10.57-8-44.94-11.63-64l-6.4,45.43A83.49,83.49,0,0,1,324.3,303c1.5,14-3.87,40.92-5.69,52.66a25.75,25.75,0,0,0-.27,5.19c0,.5,1.5,5.34-4.69,5.82S303.25,362.94,303.24,362.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,186.5s6.86,13,9.87,25.62,2.86,20.92,2.74,42.93-.44,41.13-.44,41.13a30.16,30.16,0,0,1,3.33,7.12c1.87,5.81,3.52,12.27,4.28,29.25,0,0-9.24,7.44-20.67,4.49,0,0-8.32-23.56-10.77-31.12-3.17-9.78-10.63-62.86-10.63-62.86l-5.18,45.51s3.91,10.88,3.4,18.57S323.25,327,323.25,327s-10.91,3.68-22-1.45c0,0-3-35.83-3.5-48.8s-2.06-58.75,4.3-87.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,186.5s6.86,13,9.87,25.62,2.86,20.92,2.74,42.93-.44,41.13-.44,41.13a30.16,30.16,0,0,1,3.33,7.12c1.87,5.81,3.52,12.27,4.28,29.25,0,0-9.24,7.44-20.67,4.49,0,0-8.32-23.56-10.77-31.12-3.17-9.78-10.63-62.86-10.63-62.86l-5.18,45.51s3.91,10.88,3.4,18.57S323.25,327,323.25,327s-10.91,3.68-22-1.45c0,0-3-35.83-3.5-48.8s-2.06-58.75,4.3-87.43Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.29,243.18l-5.12-20.06s-9.85,1.14-17.6-4.59c0,0,1.59,7.33,15.32,9.53l5.86,19.69-.09,9.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.28,397.08c-.4.42-.16,3.49.35,4.19s3.31,3,8.48,3.11c4.94.09,9.3-.81,12.09-2.8s4.08-4.09,4.21-6.91-.34-5.51.88-7.74c1.13-2.06,2.67-4.09,3-5.19.81-2.4,0-6,0-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,373.3a12.71,12.71,0,0,1-.43,3.15,28.66,28.66,0,0,1-2.68,6.33,26.76,26.76,0,0,1-1.9,3c-1.39,1.85-3.16,3.4-4.65,5.19a10.07,10.07,0,0,0-2.71,6.2c0,3.88,4.26,5,7.51,5.36a23.64,23.64,0,0,0,10.46-1.09,9.62,9.62,0,0,0,6.64-8.07c.12-1.08,0-2.17.07-3.26a15.24,15.24,0,0,1,2.64-6.92,20.15,20.15,0,0,0,2.1-3.8c.88-2.44-.07-5.08-.84-7.43-.67-2-1.2-4.47-1.91-4.24,0,.42,0,1.33,0,1.33-.22.46-.73.79-.85,1.32a10.12,10.12,0,0,1-.5,1.62,4.25,4.25,0,0,1-1.62,2c-.12-1.46-.25-2.91-.38-4.36a2,2,0,0,0-.4-1.27,2.08,2.08,0,0,0-1.26-.47,27.55,27.55,0,0,0-8.3-.24,1.48,1.48,0,0,0-1.08.55,1.58,1.58,0,0,0-.13,1A36,36,0,0,1,358.26,373.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,383.62c1.38-1.15,4.6-1.34,6.37-1.25a10.72,10.72,0,0,1,5.1,1.49,1.13,1.13,0,0,0,1.47-.2h0a1.07,1.07,0,0,0-.2-1.63,10.84,10.84,0,0,0-5.74-1.78c-4.35-.08-5.59.73-5.59.73S354.18,382.36,354.67,383.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.58,387.75c1.75-1.16,5.3-1.2,7.07-1.1a10,10,0,0,1,5,1.58,1.15,1.15,0,0,0,1.47-.19h0a1.08,1.08,0,0,0-.2-1.64,11.3,11.3,0,0,0-5.88-1.94c-4.35-.07-5.43.87-5.43.87A3.59,3.59,0,0,0,351.58,387.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,376a10.9,10.9,0,0,0-5.42.75c-.75.47-1.18,1.71-.68,2a10,10,0,0,1,4.8-.93,14.43,14.43,0,0,1,4.76,1c.38.14.83.35,1.22.54a1,1,0,0,0,1.4-.52h0a1,1,0,0,0-.44-1.22A14,14,0,0,0,363.17,376Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7,382.81a4.56,4.56,0,0,0,.36,3.32c.52.95,5.76,3.54,12.59,2.71a28.58,28.58,0,0,0,13.92-5.72c2.53-1.87,5.23-2.34,8.62-2.72s5.94-1.56,6.6-3.18-.35-4.32-.35-4.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.33,361.08a15.84,15.84,0,0,1-1.83-.51,1.44,1.44,0,0,0-1-.06c-.43.18-.57.71-.66,1.17a17.54,17.54,0,0,1-.59,3,7.56,7.56,0,0,1-1.82,2.13,31.76,31.76,0,0,1-5.3,3.83c-2.17,1.33-4.32,2.38-6.58,3.54s-5.4,2-7.18,3.35c-2.59,2-2.69,6.54.47,8.17,2.73,1.42,9.78,2.72,17,.26,3.92-1.34,8.1-5.83,13.3-6.51,3.31-.44,7.72-1,9.72-3.6.73-1.16.1-4.4-.5-8.24-.53-3.43-1-8.81-2.07-8.46,0,0,0,1,0,1-.26.44-1.11,1.24-1.43,1.64a9.57,9.57,0,0,1-.93.87,14.83,14.83,0,0,1-1.17,1.21,3.36,3.36,0,0,1-1.91.8,1.85,1.85,0,0,1-1-.21c-.57-.33-.64-1.07-1.1-1.53a5.57,5.57,0,0,0-1.85-1.2,10.82,10.82,0,0,0-3-.61A4.5,4.5,0,0,1,305.33,361.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12,368.69a3.05,3.05,0,0,1,2.36-1.77c1.5-.37,4.22.6,6,1.88a1.25,1.25,0,0,1-.07,2.06h0a1.25,1.25,0,0,1-1.43-.09A9.5,9.5,0,0,0,297.12,368.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.58,371.56a3.53,3.53,0,0,1,2.82-1.65s4-.1,6.52,2a1.21,1.21,0,0,1-.07,2h0a1.19,1.19,0,0,1-1.37-.08A9.48,9.48,0,0,0,292.58,371.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.53,374.2a4,4,0,0,1,3-1.51,10.63,10.63,0,0,1,6.24,2.08,1.21,1.21,0,0,1-.06,2h0a1.19,1.19,0,0,1-1.37-.08A9.06,9.06,0,0,0,287.53,374.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,127.22c3.94-2.87,6.59-3.12,10.49-2.72l-4.62,29.11s-16.7,16.24-21.26,20.77L277.3,163.71S302.38,130.09,306.34,127.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,181a92,92,0,0,0,.19-16.64c-8-8.08-6.33-17.32-2.69-23.21,7.48-12.11,17-16.63,17-16.63l12.48-.38c1.77.2,17.12,2.42,19.08,2.93,0,0,5.28,4.48,6.72,9.62.81,2.92,1,5.85-1.61,15.38L347,168.62s-1.89,5-.93,8.44c1,3.65,6.26,12.14,9,20.54,0,0-11.86,10.61-33.61,8.15-18.59-2.1-21.3-8.36-21.3-8.36S302.14,184.38,302.36,181Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,161a13.31,13.31,0,0,1-12.84,6.68,14,14,0,0,1-11.74-7.8s.09,9.82,11.67,10.15S337.36,161,337.36,161Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.75,161.51a13.69,13.69,0,0,0-1-5,3.41,3.41,0,0,0-1.66-1.92,1.8,1.8,0,0,0-1.74.41c-1.59,1.41-4.13,4-5.8,5.34a17.18,17.18,0,0,1-5.18,3.12c-.43-.35.13-.9.39-1.26.65-.91,1.29-1.46,2-2.45s1.53-1.9,1.16-3.23a1,1,0,0,0-.7-.74,1.19,1.19,0,0,0-.84.22,32.42,32.42,0,0,0-6.39,4.19c-2.16,1.81-3.43,4.8-7.14,6.26s-7.69,1.83-14.56,2.73c-5.33.7-11.35,1.2-17.28,1.71-3.46-4.88-16.34-23.39-21.57-31.33-4-6.12-7.27-11.56-13.06-12.48-5,1.43-7,14.86-3.83,23.3,0,0,3.05,5.43,10.45,14.09,3.53,4.13,11.8,14.71,17.25,20.44,2.6,2.74,3.75,3.4,15,1.62,6.2-1,28.22-6.72,32.41-8a70.45,70.45,0,0,0,8.41-2.8c2.73-1.12,8.63-4.29,10.86-7a11.1,11.1,0,0,0,2.16-3.67A10.44,10.44,0,0,0,441.75,161.51Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.28,80.77c3.57,4.54,4.31,10.49,3.5,16.38-1.36,9.9-7.3,17.64-14.42,21-4.27,2-9.82,2.87-12.72.41-4.5-3.82-9.06-7.57-13.91-10.92-3.62-2.51-7.58-5-9.47-9-1.62-3.43-1.63-9.32,1.59-11.9-3.16-2.14-4.53-5.8-5.11-7.91-.66-2.44,0-4,1-4.87s3.79-1,5-1.12c4.66-.57,8-1.81,12.55-3.06C319,69,326.73,68.09,331.8,69c4,.72,8.62,2.26,10.66,7.83A10.22,10.22,0,0,1,348.28,80.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71,78.44c-2.95,1.55-6.87,8.57-7.3,23.71C304,115,308,118.36,310.07,119.38s6.09.68,10,.23l.41,7s-12.94,10.66.22,10.78c7.77.07,16.93-10.65,16.93-10.65l.73-16.19a4.69,4.69,0,0,0,5.46-.72c3.17-2.88,3.92-7.3,1.54-10s-6.58-2.33-8.41,1.55c0,0-2.17,1.35-4.24-3a26.3,26.3,0,0,1-10.82-4.19C314,89,312.29,81.05,311.71,78.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,98.19a1.61,1.61,0,1,0,1.77-1.51A1.64,1.64,0,0,0,320.74,98.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.86,110.23a1.62,1.62,0,0,0,1.43,1.82,1.68,1.68,0,1,0-1.43-1.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.81,89.74l-3.41,2.05a1.92,1.92,0,0,0,2.68.73A2.1,2.1,0,0,0,309.81,89.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,93l3.63,1.61a1.9,1.9,0,0,0-.93-2.6A2.09,2.09,0,0,0,323.72,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.15,97.48A1.61,1.61,0,1,0,308.93,96,1.65,1.65,0,0,0,307.15,97.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.43 95.66 314.53 107.08 308.61 104.9 315.43 95.66",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.1,119.61c4.15-.33,12.75-2.33,14.25-5.61a9.19,9.19,0,0,1-3.26,4.63c-2.65,2-10.82,3.91-10.82,3.91Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.14,98.26l-.35,6.74h0a4.6,4.6,0,0,1-4.35-4.83l.33-6.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,210.69c23.58-.51,52.62,15.43,64.85,35.6,6.12,10.09,6.87,19.32,3.14,26.09-.56,1-3.91,7.12-4.47,8.14-3.7,6.8-11.9,11.13-23.71,11.39-23.59.51-52.62-15.43-64.85-35.6-6.12-10.08-6.87-19.3-3.16-26.07.57-1,3.94-7.19,4.52-8.23C302.71,215.25,310.89,210.94,322.67,210.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,220.73c11.74,6.45,22.06,15.48,28.17,25.56s6.87,19.32,3.14,26.09c-.56,1-3.91,7.12-4.47,8.14-3.7,6.8-11.9,11.13-23.71,11.39s-25-3.61-36.68-10.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33,236.86a59.32,59.32,0,0,1,7.19,9.43c6.12,10.09,6.87,19.32,3.14,26.09-.56,1-3.91,7.12-4.47,8.14-3.7,6.8-11.9,11.13-23.71,11.39a59.45,59.45,0,0,1-11.82-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.82,
    cy: 247.21,
    rx: 30.2,
    ry: 52.31,
    transform: "translate(-37.82 430.52) rotate(-61.24)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3,200.54c.18-.31.62-.32,1-.29,2.06.16,5.34,1,6.89-.85a1,1,0,0,0,.21-1,1.17,1.17,0,0,0-.66-.56,32.56,32.56,0,0,0-7.08-2.88",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.8,189.55c-14.49,6.35-22.62,19.32-31.44,35.38l77.93,42.78c8.82-16.06,15.4-29.88,13-45.51s-7.17-23.23-8.44-29.1-.39-9.33.89-11.67,3.72-5,9.37-7,14.59-2.16,29.09-8.51,22.6-19.33,31.42-35.39L381.68,87.73c-8.81,16.06-15.41,29.9-13,45.52s7.15,23.22,8.44,29.1.38,9.32-.91,11.67-3.72,4.94-9.35,7c-3.07,1.13-7.11,1.66-12.48,2.94A94.89,94.89,0,0,0,337.8,189.55Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.33,
    cy: 246.32,
    rx: 25.66,
    ry: 44.45,
    transform: "translate(-36.77 430.51) rotate(-61.24)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.69,
    cy: 109.03,
    rx: 25.66,
    ry: 44.45,
    transform: "translate(122.67 425.35) rotate(-61.24)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.8,138.76c.64,5.82,3,10,4.38,13.6a54.37,54.37,0,0,1,2.56,7.77c1.4,6.5.85,11.9-1.69,16.53s-2.46,6-1.17,6.73,2.5,0,5-4.61,6.81-8,13.05-10.29a54.29,54.29,0,0,1,7.92-2c5.3-1.09,2.94-3.2-.65-3.94-10.42-2.16-11.87-4.86-17.37-16.21a40.55,40.55,0,0,0-5.29-8.14C380.19,135.66,375.34,134.53,375.8,138.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.58,191.24a2.68,2.68,0,1,0-3.82,1.47A2.9,2.9,0,0,0,378.58,191.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.62,226.89c7-12.2,13.87-21.94,24.92-26.6,8.73-3.68,21.12-3.65,32.61,2.65S386.71,216.8,388.89,229c2.1,11.78-2.53,22.85-9.07,35.3-2.59,4.73-8.51,7.62-17.15,7.57-17.27-.1-38.87-12-48.23-26.48-4.68-7.25-5.41-13.81-2.82-18.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.72,
    cy: 245.61,
    rx: 21.05,
    ry: 38.9,
    transform: "translate(-35.95 430.48) rotate(-61.24)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.26,62.06c23.59-.51,52.62,15.43,64.85,35.6,6.12,10.08,6.87,19.31,3.15,26.09l-4.47,8.14c-3.71,6.79-11.91,11.13-23.72,11.39-23.58.5-52.62-15.44-64.85-35.61-6.11-10.07-6.87-19.29-3.16-26.06l4.52-8.23C384.3,66.62,392.48,62.31,404.26,62.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.94,72.1c11.74,6.44,22.06,15.47,28.17,25.56S476,117,472.26,123.75l-4.47,8.14c-3.71,6.79-11.91,11.13-23.72,11.39s-24.95-3.61-36.68-10.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.92,88.23a58.73,58.73,0,0,1,7.19,9.43c6.12,10.08,6.87,19.31,3.15,26.09l-4.47,8.14c-3.71,6.79-11.91,11.13-23.72,11.39a59.41,59.41,0,0,1-11.81-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.41,
    cy: 98.58,
    rx: 30.2,
    ry: 52.31,
    transform: "translate(134.8 424.94) rotate(-61.24)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.3,163.71l15.4,7.66c3.79,4.58,5.68,7.1,9.29,11.09a59.62,59.62,0,0,0,11.43,10.21c3.31,2.21,6.5,1.55,9.21,2.3l-.33,5.57c-.25.43.24.9.67,1.15a52.87,52.87,0,0,0,11.69,5c1.38.41,3,1,3.29,2.46.21,1.18-.85,2.1-1.69,3-3,3.13-8.19,3.95-12.28,3.13-3.54-.71-7.41-3-10.46-5-3.23-2.16-5.71-4.87-8.12-6.82-3.4-2.75-15-12.39-19.66-16.61-2.69-2.44-6.57-5.94-8.44-7.88C272.74,174.23,271.4,171.56,277.3,163.71Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exclamation-marks--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.78,63.07a1.05,1.05,0,0,1,.28-.77,1,1,0,0,1,.73-.34l4.95-.23a1.08,1.08,0,0,1,1.11,1l.18,4a1,1,0,0,1-.28.76,1,1,0,0,1-.73.35l-4.95.23A1.08,1.08,0,0,1,291,67Zm-1-21.43a1.08,1.08,0,0,1,1-1.11l4.95-.22a1,1,0,0,1,.76.28,1,1,0,0,1,.35.73l.77,16.94a1,1,0,0,1-.28.76,1,1,0,0,1-.73.35l-5,.23a1,1,0,0,1-.76-.28,1,1,0,0,1-.34-.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.39,78a1.07,1.07,0,0,1-.16-.8,1,1,0,0,1,.45-.67l4.14-2.74a1.09,1.09,0,0,1,1.47.29l2.19,3.32a1,1,0,0,1,.15.79,1,1,0,0,1-.45.68l-4.13,2.74a1,1,0,0,1-.79.15,1,1,0,0,1-.68-.45ZM268.54,60.16a1,1,0,0,1-.15-.79,1,1,0,0,1,.45-.68L273,56a1.07,1.07,0,0,1,1.47.3l9.37,14.14a1,1,0,0,1,.15.79,1,1,0,0,1-.45.68l-4.13,2.74a1.07,1.07,0,0,1-1.47-.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.39,78a1.07,1.07,0,0,1-.16-.8,1,1,0,0,1,.45-.67l4.14-2.74a1.09,1.09,0,0,1,1.47.29l2.19,3.32a1,1,0,0,1,.15.79,1,1,0,0,1-.45.68l-4.13,2.74a1,1,0,0,1-.79.15,1,1,0,0,1-.68-.45ZM268.54,60.16a1,1,0,0,1-.15-.79,1,1,0,0,1,.45-.68L273,56a1.07,1.07,0,0,1,1.47.3l9.37,14.14a1,1,0,0,1,.15.79,1,1,0,0,1-.45.68l-4.13,2.74a1.07,1.07,0,0,1-1.47-.3Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg504ErrorGatewayTimeoutAmico);
export default __webpack_public_path__ + "static/media/504 Error Gateway Timeout-amico.10d7309e58efb2dc27667748b03aae55.svg";
export { ForwardRef as ReactComponent };